export const statusOptions = [
  {
    value: 'open',
    label: 'open',
    color: '#4CAF50'
  },
  {
    value: 'pending',
    label: 'pending',
    color: '#fb8c00'
  },
  {
    value: 'answered',
    label: 'answered',
    color: '#2196f3'
  },
  {
    value: 'closed',
    label: 'closed'
  },
  { value: 'closed with survey', label: 'closed with survey', color: '#e0e0e0' },
  { value: 'closed without survey', label: 'closed without survey', color: '#e0e0e0' },
  {
    value: 'cancelled',
    label: 'cancelled',
    color: '#ff5252'
  },
  {
    value: 'cancelled by customer',
    label: 'cancelled by customer',
    color: '#fd87ee'
  }
]

export const moodOptions = [
  {
    value: 'positive',
    label: 'positive'
  },
  {
    value: 'neutral',
    label: 'neutral'
  },
  {
    value: 'negative',
    label: 'negative'
  }
]

export const priorityOptions = [
  {
    label: 'Low',
    value: 'low'
  },
  {
    label: 'Medium',
    value: 'medium'
  },
  {
    label: 'High',
    value: 'high'
  }
]

export const assignmentTypes = [
  { value: 'roundrobin', label: 'Round-robin' },
  { value: 'has_fewest_tickets', label: 'Has fewest tickets' }
]



// WEBPACK FOOTER //
// ./src/constants/ticket3/ticketConstant.js